<template>
  <div class="home">
    <!-- 顶部轮播 -->
    <!-- <div class="banner1">
      <video
        src="../../assets/home.mp4"
        class="home_video"
        autoplay
        muted
        loop
      ></video>
    </div> -->
    <!-- 1. 活动：最新活动（对接 /api/space/activities） -->
    <div class="d3-cetner">
      <div class="page-title">3D CENTER</div>
      <div v-if="activityLoading || activityList.length > 0" class="new-active">
        <div class="active-name">
          <span>最新活动</span>
          <span class="hot">HOT</span>
        </div>

        <div class="swiper-box">
          <div v-if="activityLoading" class="activity-placeholder">
            加载中...
          </div>
          <swiper
            v-else-if="activityList.length > 0"
            :key="'act-' + activityList.length"
            :modules="modules"
            slides-per-view="auto"
            :space-between="10"
            :navigation="navigation"
          >
            <swiper-slide v-for="item in activityList" :key="item.id">
              <div class="slider-item" @click="onActivityClick(item)">
                <div class="slide-img-wrap">
                  <img
                    class="img"
                    :src="item.coverUrl || defaultCover"
                    alt=""
                  />
                  <span
                    class="act-badge"
                    :class="'act-badge--' + getActivityBadgeKey(item)"
                    >{{ activityBadgeLabel(item) }}</span
                  >
                </div>
                <div class="info-box">
                  <div class="desc">{{ item.description || item.title }}</div>
                  <div
                    class="flex flex-justify-between flex-end act-row-bottom"
                  >
                    <div class="left">
                      <span class="name">{{ item.title }}</span>
                      <span v-if="item.organizerName" class="organizer">{{
                        item.organizerName
                      }}</span>
                    </div>
                    <div
                      v-if="getActivityCornerMode(item) === 'ratio'"
                      class="act-count"
                    >
                      <span
                        :class="
                          enrollmentRatioClass(
                            item.enrolledCount,
                            item.maxParticipants
                          )
                        "
                      >
                        {{ item.enrolledCount ?? 0 }}
                      </span>
                      <span class="act-count-sep">/</span>
                      <span class="act-count-max">{{
                        item.maxParticipants || "—"
                      }}</span>
                    </div>
                    <div v-else class="act-over">over</div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 2. 官方出品：主城市空间入口（slug: main-city） -->
    <div class="second_title">主城市</div>
    <div
      class="banner2"
      :style="{
        backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.5) 100%), url(${defaultCover})`,
      }"
      @click="enterMainCity"
    >
      <div class="text">点击进入</div>
    </div>
    <!-- 3. 其他用户发布的空间（对接 getSpaceList：人气排序/最新发布） -->
    <div class="d3-cetner">
      <div class="game-list-box">
        <div class="down">
          <div class="search_bar">
            <div
              class="search_item"
              :class="{ active: spaceTab === 'official' }"
              @click="
                spaceTab = 'official';
                loadSpaceList();
              "
            >
              官方出品
            </div>
            <div
              class="search_item"
              :class="{ active: spaceTab === 'popular' }"
              @click="
                spaceTab = 'popular';
                loadSpaceList();
              "
            >
              人气排序
            </div>
            <div
              class="search_item"
              :class="{ active: spaceTab === 'latest' }"
              @click="
                spaceTab = 'latest';
                loadSpaceList();
              "
            >
              最新发布
            </div>
          </div>
        </div>
        <div
          class="game-list flex flex-justify-between"
          v-loading="spaceLoading"
        >
          <div
            class="game-item"
            v-for="s in spaceList"
            :key="s.id"
            @click="enterSpace(s)"
          >
            <img
              class="post"
              :src="s.thumbnailUrl || s.thumbnail || defaultCover"
              alt=""
            />
            <div class="info-box flex flex-justify-between">
              <div class="user">
                <img
                  class="avator"
                  :src="getSpaceAuthorAvatar(s)"
                  alt=""
                  @error="onAuthorAvatarError"
                />
                <span class="author">作者：{{ getSpaceAuthorName(s) }}</span>
              </div>
              <div class="price-more flex">
                <div class="price">{{ s.name }}</div>
                <div class="more">
                  <div class="num flex flex-align-center">
                    <span class="special">{{ s.views ?? 0 }}</span>
                    <span>/浏览</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ActivityDetailDialog
      v-model="activityDetailOpen"
      :activity-id="selectedActivityId"
      @signup-success="onActivitySignupSuccess"
    />
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { ref, onMounted } from "vue";
import { Navigation } from "swiper/modules";
import { getActivityList, getSpaceList } from "@/api/space";
import ActivityDetailDialog from "@/components/ActivityDetailDialog.vue";
import { getSpaceAuthorAvatar, getSpaceAuthorName } from "@/utils/spaceAuthor";
import {
  getActivityBadgeKey,
  ACTIVITY_BADGE_LABEL,
  getActivityCornerMode,
} from "@/utils/activityUi";
import "swiper/css";
import "swiper/css/navigation";
/** 活动/空间无封面时使用的默认图 */
const defaultCover =
  "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/universe/universe.png";
const navigation = ref({
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
});
const modules = [Navigation];

const activityList = ref([]);
const activityLoading = ref(true);
const activityDetailOpen = ref(false);
const selectedActivityId = ref(null);

function activityBadgeLabel(item) {
  const k = getActivityBadgeKey(item);
  return ACTIVITY_BADGE_LABEL[k] || "";
}

function enrollmentRatioClass(enrolled, max) {
  const m = Number(max) > 0 ? Number(max) : 0;
  const e = Number(enrolled) || 0;
  if (m <= 0) return "ratio--neutral";
  return e / m > 0.6 ? "ratio--high" : "ratio--low";
}
const spaceList = ref([]);
const spaceTab = ref("popular");
const spaceLoading = ref(false);

const MAIN_CITY_SLUG = "main-city";

const loadActivities = async () => {
  activityLoading.value = true;
  try {
    const res = await getActivityList({ size: 12 });
    if (res?.code === 200 && Array.isArray(res.data)) {
      activityList.value = res.data;
    } else {
      activityList.value = [];
    }
  } catch (_) {
    activityList.value = [];
  } finally {
    activityLoading.value = false;
  }
};

const loadSpaceList = async () => {
  spaceLoading.value = true;
  try {
    const mode =
      spaceTab.value === "latest"
        ? "latest"
        : spaceTab.value === "official"
        ? "official"
        : "popular";
    const res = await getSpaceList({ mode, page: 1, size: 24 });
    if (res?.code !== 200 || !res?.data?.content) {
      spaceList.value = [];
      return;
    }
    spaceList.value = res.data.content;
  } catch (_) {
    spaceList.value = [];
  } finally {
    spaceLoading.value = false;
  }
};

const onAuthorAvatarError = (event) => {
  const img = event?.target;
  if (!img) return;
  const fallback = getSpaceAuthorAvatar({});
  if (img.src !== fallback) {
    img.src = fallback;
  }
};

const onActivityClick = (item) => {
  selectedActivityId.value = item?.id ?? null;
  activityDetailOpen.value = true;
};

/** 报名成功后立即同步首页活动条上的报名人数（与详情接口返回一致） */
function onActivitySignupSuccess(data) {
  if (data == null || data.id == null) return;
  const id = data.id;
  activityList.value = activityList.value.map((a) =>
    String(a.id) === String(id)
      ? { ...a, enrolledCount: data.enrolledCount ?? a.enrolledCount }
      : a
  );
}

const enterMainCity = () => {
  openSpaceInNewTab(MAIN_CITY_SLUG, null);
};

function getSpaceViewUrl(slug, id) {
  const base = `${window.location.origin}${(
    process.env.BASE_URL || "/"
  ).replace(/\/$/, "")}`;
  if (slug) return `${base}/space/view/${encodeURIComponent(slug)}`;
  if (id != null) return `${base}/space/view?id=${id}`;
  return `${base}/space/view/${encodeURIComponent(MAIN_CITY_SLUG)}`;
}

function openSpaceInNewTab(slug, id) {
  window.open(getSpaceViewUrl(slug, id), "_blank");
}

const enterSpace = (s) => {
  if (s?.slug) {
    openSpaceInNewTab(s.slug, null);
  } else if (s?.id != null) {
    openSpaceInNewTab(null, s.id);
  }
};

onMounted(() => {
  loadActivities();
  loadSpaceList();
});
</script>
<style lang="scss" scoped>
.home {
  background-color: transparent;
  min-height: 100vh;
  padding: 86px 240px 0 240px;
}

.banner1 {
  // width: 1440px;
  // height: 697px;
  // background: #f9d7d7;
  margin-top: 30px;
  .home_video {
    width: 100%;
  }
}

.threeD_content {
  width: 100%;
  height: 587px;
  border-radius: var(--ios-radius-lg, 20px);
  background: var(--ux-card-bg);
  border: 0.5px solid var(--ios-separator, rgba(255, 255, 255, 0.08));
}
.second_title {
  font-weight: bold;
  font-size: 32px;
  color: var(--ux-text-primary);
  line-height: 38px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  position: relative;
  padding-bottom: 14px;
  &::after {
    content: "";
    display: block;
    width: min(200px, 40vw);
    height: 3px;
    margin: 14px auto 0;
    border-radius: 2px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(0, 212, 255, 0.9),
      rgba(167, 139, 250, 0.95),
      rgba(0, 212, 255, 0.9),
      transparent
    );
    box-shadow: 0 0 16px rgba(0, 212, 255, 0.45);
  }
}
.banner2 {
  width: 100%;
  height: 662px;
  background-color: var(--ux-bg-deep);
  background-size: cover;
  background-position: center;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: var(--ios-radius-lg, 20px);
  margin-top: 35px;
  position: relative;
  cursor: pointer;
  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 210px;
    height: 82px;
    background: var(--ux-surface-solid);
    border-radius: 60px;
    opacity: 0.36;
    line-height: 82px;
    font-weight: bold;
    font-size: 32px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    text-transform: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      opacity: 0.6;
      transform: translate(-50%, -50%) scale(1.05);
    }
  }
}

.page-title {
  font-weight: bold;
  font-size: 80px;
  color: var(--ux-text-primary);
  line-height: 94px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-bottom: 132px;
}
.new-active {
  .active-name {
    font-weight: 400;
    font-size: 24px;
    color: var(--ux-text-primary);
    line-height: 28px;
    font-style: normal;
    text-transform: none;
    .hot {
      color: #e50000;
      font-family: Miltonian Tattoo-Regular;
      margin-left: 14px;
    }
  }
  .active-list {
    margin-top: 61px;
    overflow-x: auto;
    .active-item {
      margin-right: 11.2px;
      width: 25%;
      .poster {
        width: 100%;
        // height: 212px;
      }
    }
  }

  .swiper-box {
    margin: 60.998px auto;
    padding: 30px 6px 0 6px;
    position: relative;
    min-height: 320px;
    :deep(.swiper-slide) {
      width: 354px;
      max-width: 354px;
    }
    .activity-placeholder {
      min-height: 320px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--ux-text-muted);
      font-size: 16px;
    }
    .slider-item {
      width: 344px;
      box-sizing: border-box;
      box-shadow: var(--ux-shadow-card), 0 0 0 1px var(--ux-line-dim);
      border-radius: var(--ios-radius-md, 14px);
      cursor: pointer;
      .slide-img-wrap {
        position: relative;
      }
      .img {
        width: 100%;
        aspect-ratio: 16 / 9;
        display: block;
        object-fit: contain;
        background: var(--ux-img-placeholder);
      }
      .act-badge {
        position: absolute;
        left: 8px;
        top: 8px;
        padding: 3px 9px;
        border-radius: 999px;
        font-size: 11px;
        font-weight: 600;
        background: rgba(0, 0, 0, 0.52);
        color: #9ca3af;
        backdrop-filter: blur(6px);
      }
      .act-badge--IN_PROGRESS {
        color: #ef4444;
      }
      .info-box {
        padding: 13px;
        background: var(--ux-panel-bg);
        min-height: 112px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .desc {
          font-weight: 400;
          font-size: 12px;
          color: var(--ux-text-muted);
          line-height: 14px;
          font-style: normal;
          text-transform: none;
          margin-bottom: 10px;
        }
        .act-row-bottom {
          align-items: flex-end;
          width: 100%;
        }
        .left {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          gap: 4px;
          min-width: 0;
          flex: 1;
        }
        .left .name {
          flex: 1 1 auto;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 16px;
          color: var(--ux-text-primary);
          line-height: 20px;
        }
        .organizer {
          flex: 0 0 auto;
          font-size: 12px;
          color: var(--ux-text-muted);
          line-height: 1.25;
          white-space: nowrap;
        }
        .act-count {
          font-size: 13px;
          font-weight: 600;
          flex-shrink: 0;
        }
        .act-count-sep,
        .act-count-max {
          color: var(--ux-text-secondary);
        }
        .act-over {
          font-size: 13px;
          font-weight: 700;
          color: var(--ux-text-muted);
          letter-spacing: 0.06em;
          flex-shrink: 0;
        }
        .ratio--low {
          color: #4ade80;
        }
        .ratio--high {
          color: #f87171;
        }
        .ratio--neutral {
          color: var(--ux-text-secondary);
        }
        .flex-end {
          align-items: flex-end;
        }
        .auth {
          margin-left: 8.4px;
          font-size: 12px;
          color: var(--ux-text-muted);
          line-height: 15px;
        }
        .right {
          font-size: 16.8px;
          font-weight: bold;
          color: var(--ux-text-muted);
          line-height: 23px;
        }
        .num {
          color: #17d806;
          font-family: Microsoft YaHei UI-Bold;
        }
      }
    }
  }
}

.d3-cetner {
  margin-top: 166px;
}
.game-list-box {
  margin-top: 70px;
  .down {
    margin-bottom: 42px;
    .search_bar {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 70px 0;
      .search_item {
        width: 159px;
        height: 46px;
        background: var(--ux-surface-muted);
        border-radius: var(--ios-radius-md, 14px);
        font-weight: 400;
        font-size: 20px;
        color: var(--ux-text-primary);
        line-height: 46.004px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
        margin-right: 66px;
        &.active {
          background: linear-gradient(
            135deg,
            var(--ux-accent) 0%,
            var(--ux-accent-2) 100%
          );
          color: #fff;
          box-shadow: 0 0 16px var(--ux-accent-soft);
        }
      }
      .input_dom {
        margin-left: 56px;
        display: flex;
        align-items: center;
        input {
          opacity: 0.5;
          border: none;
          width: 266px;
          height: 38px;
          background: var(--ux-surface-muted);
          border-radius: var(--ios-pill, 980px);
          opacity: 0.5;
        }
        .search-icon {
          margin-left: 14px;
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
    }
  }
  .selected {
    padding: 0 20px;
    margin-right: 27px;
    width: 159px;
    height: 46px;
    background: var(--ux-surface-muted);
    border-radius: var(--ios-radius-md, 14px);
    border: 0;
    outline: none;
  }
  .ipt {
    padding: 0 16.8px;
    width: 252px;
    height: 38px;
    background: var(--ux-surface-muted);
    border-radius: var(--ios-pill, 980px);
    opacity: 0.5;
    border: 0;
    outline: none;
    box-sizing: border-box;
  }

  .game-list {
    margin-top: 64px;
    flex-wrap: wrap;
  }
  .game-item {
    margin-bottom: 63.994px;
    width: calc(50% - 11.2px);
    .post {
      width: 100%;
      height: 324px;
      margin-bottom: 14px;
      border-radius: var(--ios-radius-md, 14px);
      overflow: hidden;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
    }
    .info-box {
      padding: 0 7px;
    }
    .avator {
      width: 44px;
      height: 44px;
      background: var(--ux-surface-muted);
      border-radius: 50%;
      object-fit: cover;
    }
    .author {
      margin-left: 14px;
      font-weight: 400;
      font-size: 16px;
      color: var(--ux-text-primary);
      line-height: 18.998px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .price {
      margin-right: 22.4px;
      padding: 0 8.4px 4.998px;
      height: 37.996px;
      line-height: 37.996px;
      border-radius: var(--ios-radius-sm, 10px);
      font-size: 22.4px;
      color: var(--ux-text-primary);
    }
    .num {
      margin: 4.998px 0;
      font-size: 16.8px;
      color: var(--ux-text-primary);
      line-height: 23.002px;
      .special {
        padding: 2.996px;
        background: var(--ux-surface-muted);
        border-radius: 50%;
      }
    }
  }
}
</style>
